module.exports = __webpack_public_path__ + "img/submit.6932384.jpg";